import cash from './cash/routes';
import food from './food/routes';
import sales from './sales/routes';
import people from './people/routes';
import service from './service/routes';
import labor from './labor/routes';
import product from './product/routes';

const routes = [
  {
    path: '/',
    alias: '/home-dashboard',
    name: 'Home',
    icon: 'mdi-home',
    component: () => import('@/components/oldDashboard/standard/main.vue')
  },
  cash,
  food,
  sales,
  service,
  people,
  labor,
  product,
];

export default routes;